import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        keycloak: null,
        cart: null,
        footerloading: false
    },
    mutations: {
        newCart: function(state, cart) {
            state.cart = cart
        },
        newFooterLoading: function(state, hide) {
            state.footerloading = hide
        }
    }
})